type InvertibleObject = Record<PropertyKey, PropertyKey>
type AllValues<T extends InvertibleObject> = {
  [P in keyof T]: { key: P; value: T[P] }
}[keyof T]
type InvertResult<T extends InvertibleObject> = {
  [P in AllValues<T>["value"]]: Extract<AllValues<T>, { value: P }>["key"]
}

export const invert = <T extends InvertibleObject>(obj: T): InvertResult<T> => {
  const returnObj = {} as InvertResult<T>

  const entries = Object.entries(obj) as [keyof T, T[keyof T]][]
  entries.forEach(([key, value]) => {
    returnObj[value] = key
  })

  return returnObj
}

export const shallowDiff = <T extends { [key: string]: unknown }>(from: T, to: T) => {
  const changesObj = {} as {
    [K in keyof T]?: { from: T[K]; to: T[K] }
  }
  const allKeys = Object.keys({ ...from, ...to }) as (keyof T)[]
  allKeys.forEach((key) => {
    if (from[key] !== to[key]) {
      changesObj[key] = {
        from: from[key],
        to: to[key],
      }
    }
  })

  return changesObj
}

export const pick = <T extends Record<string, unknown>, Key extends keyof T>(
  obj: T,
  ...keys: [Key, ...Key[]]
): Pick<T, Key> => {
  const picked = {} as Pick<T, Key>
  keys.forEach((key) => {
    // TODO ES2022がリリースされたらObject.hasOwnを使う形に変更する
    // https://github.com/tc39/proposal-accessible-object-hasownproperty
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      picked[key] = obj[key]
    }
  })
  return picked
}
